

























import { defineComponent, ref, watch } from '@vue/composition-api';
import { loggedIn } from '@/utils/auth';

export default defineComponent({
  name: 'MigrationNotice',
  setup() {
    const show = ref(false);
    // Show once when login succeeds (including restored sessions), not on API polling.
    watch(loggedIn, (value) => { show.value = value; }, { immediate: true });
    return { show };
  },
});
